function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import classnames from 'classnames';
import { useField, useFormikContext } from 'formik';
import React from 'react';
import { FormGroup, ButtonGroup, Button } from 'reactstrap';
import { Error, Label } from "./";
export default (function (_ref) {
  var name = _ref.name,
      label = _ref.label,
      value = _ref.value,
      buttonClass = _ref.buttonClass,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'sm' : _ref$size,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      _ref$groupTag = _ref.groupTag,
      groupTag = _ref$groupTag === void 0 ? FormGroup : _ref$groupTag,
      _ref$labelTag = _ref.labelTag,
      labelTag = _ref$labelTag === void 0 ? Label : _ref$labelTag,
      _ref$errorTag = _ref.errorTag,
      errorTag = _ref$errorTag === void 0 ? Error : _ref$errorTag,
      _ref$inputTag = _ref.inputTag,
      inputTag = _ref$inputTag === void 0 ? 'input' : _ref$inputTag,
      _ref$buttonTag = _ref.buttonTag,
      buttonTag = _ref$buttonTag === void 0 ? Button : _ref$buttonTag,
      _ref$buttonProps = _ref.buttonProps,
      buttonProps = _ref$buttonProps === void 0 ? {} : _ref$buttonProps,
      _ref$groupProps = _ref.groupProps,
      groupProps = _ref$groupProps === void 0 ? {} : _ref$groupProps,
      _ref$labelProps = _ref.labelProps,
      labelProps = _ref$labelProps === void 0 ? {} : _ref$labelProps,
      _ref$inputProps = _ref.inputProps,
      inputProps = _ref$inputProps === void 0 ? {} : _ref$inputProps,
      _ref$errorProps = _ref.errorProps,
      errorProps = _ref$errorProps === void 0 ? {} : _ref$errorProps;

  var _useFormikContext = useFormikContext(),
      mapping = _useFormikContext.mapping,
      setFieldValue = _useFormikContext.setFieldValue;

  var fieldContext = useField({
    name: name
  });
  var GroupTag = groupTag;
  var LabelTag = labelTag;
  var ErrorTag = errorTag;
  var InputTag = inputTag;
  var ButtonTag = buttonTag;
  label = labelProps.text || label;

  if (label === undefined) {
    label = name;
  }

  if (!Array.isArray(options)) {
    options = mapping.getChoices(name);
  }

  return /*#__PURE__*/React.createElement(GroupTag, groupProps, label && /*#__PURE__*/React.createElement(LabelTag, _extends({
    name: name,
    size: size
  }, labelProps), label), /*#__PURE__*/React.createElement(ButtonGroup, {
    className: "btn-group-toggle",
    "data-toggle": "buttons"
  }, options.map(function (item, i) {
    var active = String(item.value) === String(value === undefined ? fieldContext[0].value : value);
    var className = typeof buttonClass === 'function' ? buttonClass(item, active) : buttonClass;
    return /*#__PURE__*/React.createElement(ButtonTag, _extends({
      tag: "label",
      key: i,
      className: classnames(_objectSpread({
        active: active,
        'shadow-none': !active
      }, className)),
      color: "secondary",
      size: size
    }, buttonProps), /*#__PURE__*/React.createElement(InputTag, _extends({
      type: "radio",
      onChange: function onChange() {
        setFieldValue(name, item.value);
      },
      value: String(item.value),
      checked: active
    }, inputProps)), item.label);
  })), /*#__PURE__*/React.createElement(ErrorTag, _extends({
    name: name
  }, errorProps)));
});